import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=6cdcba9e&scoped=true&"
import script from "./QuestionsList.vue?vue&type=script&lang=js&"
export * from "./QuestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcba9e",
  null
  
)

export default component.exports